import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import * as v from "valibot";

import { LoginPage } from "#components";

export const Route = createFileRoute("/login")({
  component: Component,
  validateSearch: v.object({
    /** 前のページのパス */
    from: v.fallback(v.optional(v.string()), undefined),
  }),
});

function Component() {
  const { from } = Route.useSearch();

  const { t } = useTranslation();

  return <LoginPage from={from} name={t("%Login.0%")} />;
}
